import React from 'react'

import ElnForm from './eln.form.json'
import IsbeForm from './isbe.form.json'
import CoachForm from './coach.form.json'

export const CombineForms = () => {
	const newObj = {
		eln: ElnForm,
		isbe: IsbeForm,
		coach: CoachForm
	}

	return newObj;
}

export const FormTypes = {
	// "standard": {
	// 	id: "standard",
	// 	comps: [
	// 		"isbe"
	// 	],
	// 	title: "Standard ISBE Eval Only"
	// },
	"eln": {
		id: "eln",
		comps: [
			"eln"
		],
		title: "ELN Course Eval"
	},
    "coach": {
		id: "coach",
		comps: [
			"coach"
		],
		title: "Coach Eval for Coaching and Mentoring"
	},
    // "protege": {
	// 	id: "protege",
	// 	comps: [
	// 		"isbe",
	// 		"protege"
	// 	],
	// 	title: "Protege Eval for Coaching and Mentoring"
	// },
	// "checkinout": {
	// 	id: "checkinout",
	// 	comps: [
	// 		"checkinout"
	// 	],
	// 	title: "Event Check In/Out"
	// }
}

export const Sources = {
	"bridge": {
		id: "bridge",
		title: "ELN Online Course",
		bgUrl: "",
		headIcon: "",
		titleColor: "",
		cat: ["eln"]
	},
    "zoomWebinar": {
        id: 'zoomWebinar',
        title: "Zoom Webinar",
		bgUrl: "",
		headIcon: "",
		titleColor: "",
		cat: ["eln"]
    },
	// "odaa": {
	// 	id: "odaa",
	// 	title: "On-Demand Administrator Academy",
	// 	bgUrl: "",
	// 	headIcon: "",
	// 	titleColor: "",
	// 	cat: ["ipa"]
	// },
	// "ipaa": {
	// 	id: "ipaa",
	// 	title: "In-Person Administrator Academy",
	// 	bgUrl: "",
	// 	headIcon: "",
	// 	titleColor: "",
	// 	cat: ["ipa"]
	// },
    // "coach": {
	// 	id: "coach",
	// 	title: "Coaching and Mentoring",
	// 	bgUrl: "",
	// 	headIcon: "",
	// 	titleColor: "",
	// 	cat: ["ipa"]
	// },
	"mc": {
		id: "mc",
		title: "Micro-Credential",
		bgUrl: "",
		headIcon: "",
		titleColor: "",
		cat: ["eln"]
	},
	// "checkinout": {
	// 	id: "checkinout",
	// 	title: "Event Check In/Out",
	// 	bgUrl: "",
	// 	headIcon: "",
	// 	titleColor: "",
	// 	cat: ["ipa","eln"]
	// },
	// "none": {
	// 	id: "none",
	// 	title: "No Evaluation",
	// 	bgUrl: "",
	// 	headIcon: "",
	// 	titleColor: "",
	// 	cat: "none"
	// }
}